module.exports = __webpack_public_path__ + "img/demand.10b9409f.svg";